import React, {useState} from 'react';
import {Col, Container, Row, Accordion} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import Healthcare from "../../images/services/cto/Healthcare.svg";
import RealEstate from "../../images/services/cto/RealEstate.svg";
import Gaming from "../../images/services/cto/Gaming.svg";
import Ecommerce from "../../images/services/cto/Ecommerce.svg";
import Lifestyle from "../../images/services/cto/lifestyle.svg";


function Industries(props) {
    const [toggleState, setToggleState] = useState(1);

    const toggleTab = (index) => {
        setToggleState(index);
    };

    const getActiveClass = (index, className) =>
        toggleState === index ? className : "";

    return (
        <div className="seriveces_industries p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={7} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Result-Driven">
                            <h2>Industries We Serve</h2>
                        </div>
                        <p className="strong">Industries and diverse business sectors are highly considered because of
                            the growing significance of niche marketplaces. We help our clients tap into the right
                            niches, source products strategically then penetrate the market for guaranteed success.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="deskstop_version">
                        <div className="process_icons">
                            <ul>
                                <li className={`tabs ${getActiveClass(1, "active-tabs")}`}
                                    onClick={() => toggleTab(1)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                    </div>
                                    Healthcare
                                </li>
                                <li className={`tabs ${getActiveClass(2, "active-tabs")}`}
                                    onClick={() => toggleTab(2)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                    </div>
                                    Real Estate
                                </li>

                                <li className={`tabs ${getActiveClass(3, "active-tabs")}`}
                                    onClick={() => toggleTab(3)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                    </div>
                                    Gaming
                                </li>
                                <li className={`tabs ${getActiveClass(4, "active-tabs")}`}
                                    onClick={() => toggleTab(4)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                    </div>
                                    Ecommerce
                                </li>
                                <li className={`tabs ${getActiveClass(5, "active-tabs")}`}
                                    onClick={() => toggleTab(5)}
                                >
                                    <div className="iconss">
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                    </div>
                                    Lifestyle
                                </li>

                            </ul>

                            <div className={toggleState === 1 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol can help you establish a robust and responsive healthcare marketplace for
                                    the interaction of buyers and sellers in the mainstream healthcare and health-tech
                                    ecosystem.</p>
                            </div>
                            <div className={toggleState === 2 ? 'content d-block' : "content d-none"}>
                                <p>Chatbots in the real estate market help property managers, realtors, tenants, and
                                    home hunters hit big. They automate information provision and improve lead count and
                                    conversion because of these inquiry responses. In mobile apps and SaaS programs,
                                    these chatbots schedule property views and virtual tours, eliminating service delays
                                    and boosting visitor experience.</p>
                            </div>
                            <div className={toggleState === 3 ? 'content d-block' : "content d-none"}>
                                <p>Chatbot development in gaming helps with improving in-game support, increases in-app
                                    purchases, and boosts the player experience. While we have created customer response
                                    chatbots for game apps, we have created games that work with these AI chatbots as
                                    characters.</p>
                            </div>
                            <div className={toggleState === 4 ? 'content d-block' : "content d-none"}>
                                <p>TekRevol has helped ecommerce businesses take a step ahead in the industry. Smart AI
                                    chatbots display catalog products and make personalized recommendations. Our
                                    ecommerce chatbots record interaction data and help product managers to marketers in
                                    further manufacturing and promotions.</p>
                            </div>
                            <div className={toggleState === 5 ? 'content d-block' : "content d-none"}>
                                <p>A vast market worldwide uses various lifestyle digital products, from web apps to
                                    smartwatch widgets to desktop programs. These digital solutions provide helpful
                                    content, information, and products to the users and present immense potential for
                                    making money through multiple monetization models. TekRevol can build the proper
                                    lifestyle chatbot solution for you.</p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="mobile_version">
                        <div className="tekrevol_mobile_accordion_side">
                            <Accordion
                                defaultActiveKey="1">
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Healthcare}
                                            effect="blur" alt="Healthcare" className="img-fluid"
                                        />
                                        Healthcare
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol can help you establish a robust and responsive healthcare
                                            marketplace for the interaction of buyers and sellers in the mainstream
                                            healthcare and health-tech ecosystem.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={RealEstate}
                                            effect="blur" alt="Real Estate" className="img-fluid"
                                        />
                                        Real Estate
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Chatbots in the real estate market help property managers, realtors, tenants,
                                            and home hunters hit big. They automate information provision and improve
                                            lead count and conversion because of these inquiry responses. In mobile apps
                                            and SaaS programs, these chatbots schedule property views and virtual tours,
                                            eliminating service delays and boosting visitor experience.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="3">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Gaming}
                                            effect="blur" alt="Gaming" className="img-fluid"
                                        />
                                        Gaming
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>Chatbot development in gaming helps with improving in-game support, increases
                                            in-app purchases, and boosts the player experience. While we have created
                                            customer response chatbots for game apps, we have created games that work
                                            with these AI chatbots as characters.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="4">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Ecommerce}
                                            effect="blur" alt="Ecommerce" className="img-fluid"
                                        />
                                        Ecommerce
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol has helped ecommerce businesses take a step ahead in the industry.
                                            Smart AI chatbots display catalog products and make personalized
                                            recommendations. Our ecommerce chatbots record interaction data and help
                                            product managers to marketers in further manufacturing and promotions.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="5">
                                    <Accordion.Header>
                                        <LazyLoadImage
                                            src={Lifestyle}
                                            effect="blur" alt="Lifestyle" className="img-fluid"
                                        />
                                        Lifestyle
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <p>A vast market worldwide uses various lifestyle digital products, from web
                                            apps to smartwatch widgets to desktop programs. These digital solutions
                                            provide helpful content, information, and products to the users and present
                                            immense potential for making money through multiple monetization models.
                                            TekRevol can build the proper lifestyle chatbot solution for you.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Industries;